/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Pause/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Action from './Action/index'
import Details from './Details/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Pause({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/DentalMonitoring/Content/Started/Pause"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Action'
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'Action'}>
<Action
  viewPath={`${viewPath}/Action`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Details'}>
<Details
  viewPath={`${viewPath}/Details`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}